import GalleryHoverContainer from "../../../components/miscellaneous/gallery/galleryHover";

const GalleryHover = () => {
  return <GalleryHoverContainer />;
};

export default GalleryHover;
